import { createSlice } from '@reduxjs/toolkit';

export const AuthSlice = createSlice({
  name: 'AuthReducer',
  initialState: {
    id: '',
    email: '',
    roles: [],
    firstname: '',
    lastname: '',
    isCustomer: '',
  },
  reducers: {
    AuthLogin(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    AuthLogout(state) {
      state.email = '';
      state.roles = [];
      state.firstname = '';
      state.lastname = '';
      state.id = '';
      state.isCustomer = '';
    }
  },
});

export const { AuthLogin, AuthLogout } = AuthSlice.actions;
export default AuthSlice.reducer;
